/**
 * 转账弹出框
 */
import React, {Component, PropTypes} from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {MONEY} from '../../constants/regulars'
import ReactDOM from 'react-dom';
import * as userAction from '../../actions/userAction'

class TransferMoney extends React.Component {

  constructor(props) {
    super(props);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleTrans = this.handleTrans.bind(this);
    this.hideFn = this.hideFn.bind(this)
    this.state = {
      focus: 'input'
    }
  }

  // 切换选中
  handleFocus(type) {
    this.setState({
      focus: type
    })
    // 清空数据
    if (type === 'input') {
      ReactDOM.findDOMNode(this.refs.output).value = '';
    } else {
      ReactDOM.findDOMNode(this.refs.input).value = '';
    }
  }

  // 新打开的时候
  componentWillReceiveProps(nextProps) {
    if (nextProps.display && !this.props.display) {
      ReactDOM.findDOMNode(this.refs.output).value = '';
      ReactDOM.findDOMNode(this.refs.input).value = '';
    }
  }

  // 去转账
  handleTrans() {
    const {platform, hideFn, url} = this.props;
    const _platform = _.lowerCase(platform);

    let transMoney = '', toPlatform, fromPlatform;
    // 转账类型
    if (this.state.focus == 'input') {
      transMoney = ReactDOM.findDOMNode(this.refs.input).value;
      toPlatform = _platform;
      fromPlatform = 'lottery';
    } else {
      transMoney = ReactDOM.findDOMNode(this.refs.output).value;
      toPlatform = 'lottery';
      fromPlatform = _platform;
    }
    // 校验
    if (!MONEY.test(transMoney)) {
      alert('请输入正确金额且不能小于0！');
      return;
    }

    // hideFn();
    this.props.$$BASE.closeTransferModal();
    this.props.$$USER.transferBalance(toPlatform, fromPlatform, transMoney, url);

  }

  hideFn() {
    this.props.$$BASE.closeTransferModal();
    this.props.$$BASE.closeOverlay();
    if(this.props.hideFn) this.props.hideFn()
  }

  render() {
    const {platform, display} = this.props;
    const _platformName = platform == 'ibc' ? '体育' : platform=='WALI' ? '瓦力棋牌': platform=='YY' ? '云游棋牌' : platform;
    const __user = this.props.__USER.toJS();
    return (
      <div className={"modal-charge-cont"} style={{ display: display ? "block" : "none" }}>
        <div className="chargebg">
          <h2 id="chargeTitle">
            {_platformName}
            transfer
            <a className="close-icon" onClick={this.hideFn}>
              X
            </a>
          </h2>
          <div className="charge_input">
            <p>
              transfer-in amount：
              <input
                className={this.state.focus == "output" ? "disabled" : null}
                placeholder="Please fill in the transfer-in amount"
                ref="input"
                onFocus={this.handleFocus.bind(this, "input")}
              />
              <span>　至{_platformName}account</span>
            </p>
            <label className="balance">
              {platform ? "the current account balance of the lottery:" + __user.balance["lottery"] : " "}
            </label>
            <p>
              transfer-out amount：
              <input
                className={this.state.focus == "input" ? "disabled" : null}
                placeholder="Please fill in the transfer-out amount"
                ref="output"
                onFocus={this.handleFocus.bind(this, "output")}
              />
              <span>　to lottery account</span>
            </p>
            <label className="balance">
              {platform ? _platformName + "the current account balance:" + __user.balance[platform.toLowerCase()] : " "}
            </label>
          </div>
          <div className="submit-box">
            <input type="button" value="confirm" className="charge_btn" onClick={this.handleTrans} />
          </div>
        </div>
      </div>
    );
  }

  AG

}

reactMixin(TransferMoney.prototype, ImmutableMixin);


function mapStateToProps(state) {
  return {
    __USER: state.user
  }
}


function mapDispatchToProps(dispatch) {
  return {
    $$USER: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransferMoney)